import { createSlice } from '@reduxjs/toolkit'

import _ from 'lodash'

export const currentStateSlice = createSlice({
    name: 'currentState',
    initialState: { value: { id: 0 }},
    reducers: {
        setCurrentState: (state, action) => {
            state.value = action.payload
        }
    },
})

export const currentRegionSlice = createSlice({
    name: 'currentRegion',
    initialState: { value: { id: 0 }},
    reducers: {
        setCurrentRegion: (state, action) => {
            state.value = action.payload
        }
    },
})

export const poiTypesSlice = createSlice({
    name: 'poiTypes',
    initialState: { value: {}},
    reducers: {
        setPoiTypes: (state, action) => {
            const { ids, selected } = action.payload;
            _.each(ids, poiType => {
                state.value[poiType] = selected;
            })
        },
        selectAllPoiTypes: (state, action) => {
            state.value = {}
        }
    },
})

export const { setCurrentState } = currentStateSlice.actions
// export default currentStateSlice.reducer

export const { setCurrentRegion } = currentRegionSlice.actions
// export default currentRegionSlice.reducer

export const { setPoiTypes, selectAllPoiTypes } = poiTypesSlice.actions
